export default __webpack_public_path__ + "static/media/egalitarian-1.0cae4e15.jpg";